<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="1100px"
    append-to-body
  >
    <!-- 搜索区域 -->
    <div class="filter-container">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="VIN码">
          <el-input v-model="form.vin" placeholder="请输入VIN码"></el-input>
        </el-form-item>
        <el-form-item label="生产订单号">
          <el-input
            v-model="form.orderNum"
            placeholder="请输入生产订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="生产日期">
          <el-date-picker
            v-model="form.manufactureDate"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" size="small" @click="searchClick"
          >查询</el-button
        >
        <el-button type="primary" plain size="small" @click="handleReset"
          >重置</el-button
        >
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div>
      <el-table ref="tableRef" :data="vinList" stripe border>
        <!-- 序号 -->
        <el-table-column
          label="序号"
          width="60px"
          align="center"
          type="index"
        ></el-table-column>
        <!-- 故障车VIN码 -->
        <el-table-column
          prop="vin"
          label="VIN码"
          min-width="160px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="生产订单号"
          min-width="160"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="manufactureDate"
          label="生产日期"
          min-width="160"
          align="center"
        >
        </el-table-column>
      </el-table>
      <div class="fenye" v-if="total > 0">
        <pagination
          :total="total"
          :page.sync="currentPage"
          :limit.sync="pageSize"
          @pagination="pageOperation"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      title: "",
      dialogVisible: false,
      vinList: [],
      vinAllList: [],
      form: {
        vin: "",
        orderNum: "",
        manufactureDate: "",
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(title, data = []) {
      this.title = title;
      this.dialogVisible = true;
      this.vinAllList = data || [];
      this.total = this.vinAllList.length;
      this.pageOperation();
    },
    // 分页
    pageOperation() {
      var allList = this.vinAllList;
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      if (allList.length > end) {
        this.vinList = allList.slice(start, end);
      } else if (allList.length > start) {
        this.vinList = allList.slice(start, allList.length);
      } else {
        this.vinList = [];
      }
    },
    // 搜索
    searchClick() {},
    // 重置
    handleReset() {
      this.form = {
        vin: "",
        orderNum: "",
        manufactureDate: "",
      };
      this.$nextTick(function () {
        this.$refs.form.resetFields();
      });
    },
  },
};
</script>
